import EfBundlesCard from '@elem/ui/ef-bundles-card';
import EfTitle from '@elem/ui/ef-title';
import EFSGS from 'elem/ui-assets/icons/unregular/EFSGS';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { dataLocal } from './../configs';
import styles from './index.module.scss';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useLang } from '@/i18n';

const arror = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9.45855 3.77295L17.2363 11.5507L9.45855 19.3285" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function Bundles() {
    const { t } = useLang('delta3series.bundles');
    const { locale = 'us' } = useRouter();
    const IS_AU_SITE = locale === 'au';
    const { data } = dataLocal[locale];
    const [gap, setGap] = useState(16);
    const [cards, setCards] = useState(data);
    const [init, setInit] = useState(false);
    const btnText2 = t('btn_2');
    const btnText = btnText2;

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : 16);
        }

        const tempData = JSON.parse(JSON.stringify(cards));
        const getAsynItem = async (productId: string, variantId: string, k: number, m?: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        const item = typeof m === 'number' && m >= 0 ? tempData[k].subs[m] : tempData[k];
                        item.discountPrice = res?.data?.price || 234560;
                        item.originalPrice = res?.data?.compareAtPrice ?? (res?.data?.price || 321000);
                        item.inventoryQuantity = res?.data?.inventoryQuantity || 100;
                        const title = res.data?.skuTitle == 'Default Title' ? res.data?.productTitle : res.data?.skuTitle;
                        item.title = title || item.name;
                        item.img = res.data?.variantImg || res.data?.img || item.img;
                        if (typeof m === 'number' && m >= 0) {
                            item.parentVarientId = tempData[k].variantId;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        // const promises = tempData?.map((item: EfBundlesCardProps) => getAsynItem(item, ''));
        const promises: any[] = [];
        tempData?.map((item: any, k: number) => {
            if (item?.variantId) {
                promises.push(getAsynItem(item?.productId, item?.variantId, k));
                if (item?.subs?.length > 0) {
                    item?.subs?.map((sub: any, m: number) => promises.push(getAsynItem(sub?.productId, sub?.variantId, k, m)));
                }
            }
        });
        Promise.all(promises)
            .then(() => {
                setCards(tempData);
                setInit(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    const prevRef = useRef<HTMLDivElement>(null);
    const nextRef = useRef<HTMLDivElement>(null);
    return (
        <div className={styles.bundles}>
            {init && <EfTitle hasAnimation={false}>{t('title')}</EfTitle>}
            {init && (
                <Swiper
                    className="swiper-cards"
                    modules={[Navigation]}
                    spaceBetween={gap}
                    loop={false}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    slidesPerGroup={2}
                    navigation={{
                        prevEl: '.bundle-button-prev',
                        nextEl: '.bundle-button-next',
                    }}
                    autoplay={false}
                    onReachBeginning={() => {
                        if (!prevRef.current) return;
                        prevRef.current.classList.add('active');
                    }}
                    onFromEdge={() => {
                        if (prevRef.current && nextRef.current) {
                            prevRef.current.classList.remove('active');
                            nextRef.current.classList.remove('active');
                        }
                    }}
                    onReachEnd={() => {
                        if (!nextRef.current) return;
                        nextRef.current.classList.add('active');
                    }}
                >
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className="swiper-card" key={k}>
                            <EfBundlesCard
                                {...card}
                                affirmIconUrl={IS_AU_SITE ? 'https://websiteoss.ecoflow.com/upload/image/1736999133638/payment%20method.png' : undefined}
                                hasAffirm={true}
                                buyText={btnText}
                            />
                            {k !== cards?.length - 1 && <EFSGS />}
                        </SwiperSlide>
                    ))}

                    {/* 切换按钮 */}
                    {init && cards?.length && IS_AU_SITE && (
                        <div className="bundle-navigation">
                            <div className="bundle-button-prev bundle-button active" ref={prevRef}>
                                {arror}
                            </div>
                            <div className="bundle-button-next bundle-button" ref={nextRef}>
                                {arror}
                            </div>
                        </div>
                    )}
                </Swiper>
            )}
        </div>
    );
}
